(function($) {
	'use strict'; 
	var variantSelect = null;
	function selectedFitName() {
		if (variantSelect) {
			let fitOptions = variantSelect.find('.swatch-item-fit');
			if (fitOptions.length != 0) {
				let fit = variantSelect.find('.swatch-item-fit:checked').data('size-value').toLowerCase();
				return fit;
			}
		}
		return 'standard';
	}

	function selectedSizeName() {
		if (variantSelect) {
			let sizeOptions = variantSelect.find('.swatch-item-size');
			if (sizeOptions.length != 0) {
				let size = variantSelect.find('.swatch-item-size:checked').data('size-value').toLowerCase();
				return size;
			}
		}
		return '';
	}

	function updateSwatchAvailability() {
		$('.variant-picker').each(function() {
			variantSelect = $(this);
			let fit = selectedFitName();
			let size = selectedSizeName();
            console.log(fit, size);
			if (variantSelect) {
                console.log(`swatch-item-color[data-szav-${fit}-${size}="1"]`);
				variantSelect.find(`.swatch-item-color[data-szav-${fit}-${size}="0"] + label`).addClass('is-disabled');
				variantSelect.find(`.swatch-item-color[data-szav-${fit}-${size}="1"] + label`).removeClass('is-disabled');
			}
		});
	}

	$(document).on('change', '.variant-picker__option.swatch-size .swatch-item-size', function(e) {
        // e.preventDefault();
        console.log('Size Change');
		updateSwatchAvailability();
	});

    $(document).on('change', '.variant-picker__option.swatch-color-fieldset .swatch-item-color', function(e) {
        // e.preventDefault();
        variantSelect = $(this).parents('.variant-picker');
		let fit = selectedFitName();
		let size = selectedSizeName();
		let variant = $(this).data(`variant-${fit}-${size}`);
		let href = $(this).data('href');
        href = `https://${Shopify.shop}${href}`;
        console.log(href, $(this), variant);
		let url = new URL(href);
		const urlParams = new URLSearchParams(window.location.search);
		urlParams.set('variant', variant);
		window.location.replace(`${url.origin}${url.pathname}?${urlParams.toString()}`);
	});
    
	$(document).on('click', '.xcvi-color-swatch-item .swatch-link', function(e) {
		e.preventDefault();
		variantSelect = $(this).parents('.ProductForm__Variants');
		let fit = selectedFitName();
		let size = selectedSizeName();
		let variant = $(this).data(`variant-${fit}-${size}`);
		let href = $(this)[0].href;
		let url = new URL(href);
		const urlParams = new URLSearchParams(window.location.search);
		urlParams.set('variant', variant);
		window.location.replace(`${url.origin}${url.pathname}?${urlParams.toString()}`);
	});

	updateSwatchAvailability();

	$(document).on('change', '.ColorSwatch__Radio', function() {
		let radio = $(this);
		let image = radio.data('featured_image');
		let alt_image = radio.data('alternate_image');
		let color_name = radio.data('color-name');
		let price = radio.data('price');
		let wrapper = radio.parents('.ProductItem__Wrapper'); 
		wrapper.find('.ProductItem__Image').attr('srcset', image);
		wrapper.find('.ProductItem__Image.ProductItem__Image--alternate').attr('srcset', alt_image);
		wrapper.find('.ProductItem__PriceList .ProductItem__Price').html(price);
		let anchor = wrapper.find('.ProductItem__Title.Heading a');
		var title = anchor.data('title');
		if (color_name) {
			title = `${title}<span class="colortitle"> in ${color_name}</span>`;
		}
		wrapper.find('.ProductItem__Title.Heading a').html(title);
	});

	const swatchDebugVerbose = false;
	let collectionHandle;
	if(document.body.classList.contains('template-collection') || true) {
		let page = 1;
		collectionHandle = 'all';
		if (sessionStorage.getItem('collProdsFetchDate') === null) {
			sessionStorage.setItem('collProdsFetchDate', Date.now());
		}
		if (sessionStorage.getItem('collProdsPriceUpdate') === null) {
			sessionStorage.setItem('collProdsPriceUpdate', 'Yes');
			sessionStorage.removeItem('collProdsImgData');
		}
		if (sessionStorage.getItem('collProdsColorUpdate') === null) {
			sessionStorage.setItem('collProdsColorUpdate', 'Yes');
			sessionStorage.removeItem('collProdsImgData');
		}
		const fetchCollProdsSwatchDataPage = () => { 
			if(!!swatchDebugVerbose) { console.log('%c[fetchCollProdsSwatchDataPage]', 'background-color: rgba(255,0,0,0.3)'); }
			let lastFetchTime = sessionStorage.getItem('collProdsFetchDate');
			let diff = Date.now() - lastFetchTime;
			let timeThreshold = (1*60*60*1000);
			if(!!sessionStorage.getItem('collProdsImgData') && diff < timeThreshold) { 
				if(!!swatchDebugVerbose) { console.log('%cretrieved saved data', 'background-color: rgba(0,255,0,0.3)'); }
				window.collSwatchFetchComplete = true;
				return;
			}
			fetch(`/collections/${collectionHandle}/?view=swatch-data${page > 1 ? `&page=${page}` : ''}`, {
				credentials: 'same-origin',
				method: 'GET'
			}).then(function (response) {
				response.text().then(content => {
					if(!!content && content.includes('window.collProdsImgData')) { 
						if(!!swatchDebugVerbose) { 
							console.log('%cAppend fetchCollProdsSwatchDataPage script tag (' + content.length + ')', 'background-color: rgba(255,0,0,0.1)'); 
						}
						const newScriptTag = document.createElement('script');
						newScriptTag.setAttribute('class', 'script-swatch-data');
						newScriptTag.setAttribute('data-page', page);
						newScriptTag.innerHTML = content;
						document.body.appendChild(newScriptTag);
						if(!!swatchDebugVerbose) { 
							console.log('swatches', !!window.collProdsImgData ? window.collProdsImgData.split('[,]').filter(item => !!item).length : 'Not initialized'); 
						}
						page++;
						setTimeout(fetchCollProdsSwatchDataPage, 1000);
					} else {
						if(sessionStorage.getItem('collProdsImgData') === null || sessionStorage.getItem('collProdsImgData') === '') {
							sessionStorage.setItem('collProdsImgData', window.collProdsImgData);
							sessionStorage.setItem('collProdsFetchDate', Date.now());
						}
						window.collSwatchFetchComplete = true;
					}
				});
			});
		};
		fetchCollProdsSwatchDataPage();
	}

	function renderCollectionSwatch(parent, data)
	{
        // `<div class="ProductItem__ColorSwatchItem">
        //       <input class="ColorSwatch__Radio" type="radio" data-price="${data.price}" data-featured_image="${data.image}" data-color-name="${data.color}" data-alternate_image="${data.image1}" name="${data.color}" id="${data.colorId}" value="${data.value}" data-image-url="${data.imageUrl}" data-variant-url="/products/${data.handle}">
        //       <label class="ColorSwatch ColorSwatch--small" for="${data.colorId}" style="${data.style}" title="${data.title}" data-tooltip="${data.title}"></label>
        //   </div>`;
        data.name = $(parent).data('paramname');
        data.checked = '';
        if (data.isSelected) {
            data.checked = 'checked';
        }
        let swatch = `<input class="sr-only custom-swatch-radio" ${data.checked} type="radio" name="${data.name}" id="${data.colorId}" value="${data.value}" data-price="${data.price}" data-primary-image-url="${data.image}" data-secondary-image-url="${data.image1}" data-handle="${data.handle}" data-variant-url="/products/${data.handle}">
				<label class="color-swatch custom-swatch" for="${data.colorId}" style="${data.style}">
      				<span class="sr-only">${data.value}</span>
    			</label>`;
        return swatch;
	}

	window.renderCollProdItemSwatches = ($productItemAnchor) => 
	{
		const $productItem = $productItemAnchor.closest('.product-card');
		const $sectionID = $productItem.getAttribute('data-section-id');
		const $productID = $productItem.getAttribute('data-product-id');
		const productHandle_old = $productItemAnchor.getAttribute('href').split('/').filter(item => !!item);
		const productHandle_old1 = productHandle_old[productHandle_old.length-1].split('?');
		const productHandle = productHandle_old1[0];

		const $swatchesWrap = $productItem.getElementsByClassName('card-color-swatch-list')[0];
		let swatchItemsHTML = '';
		let swatchesShown = 0;
		let swatchesTotal = 0;
		var prodImgData = window._collProdsImgData[productHandle];
		if (prodImgData) 
		{
			let prodImgDataRelationGroup = prodImgData[6];
			let color_name = `${$sectionID}-${$productID}`;
			if(typeof prodImgData !== 'undefined' && typeof prodImgDataRelationGroup !== 'undefined') 
			{
                // console.log(prodImgData);
				if(!!prodImgData) 
				{
					let color_id = `${$sectionID}-${$productID}-0`;
					swatchItemsHTML += renderCollectionSwatch($swatchesWrap, {
						value: prodImgData[0],
						title: prodImgData[0],
						style: prodImgData[1],
						imageUrl: prodImgData[1],
						image: prodImgData[2],
						image1: prodImgData[3], 
						price: prodImgData[4], 
						color: prodImgData[5],
						colorName : color_name,
						colorId: color_id,
						handle: productHandle,
                        isSelected : true
					});
					swatchesShown++;
					swatchesTotal++;
				}
				prodImgDataRelationGroup = prodImgDataRelationGroup.split(',');
				prodImgDataRelationGroup.forEach((groupItem, loopIndex) => {
					let color_id = `${$sectionID}-${$productID}-${loopIndex + 1}`;
					if(typeof window._collProdsImgData[groupItem] !== 'undefined') {
						let prodImgData = window._collProdsImgData[groupItem];
						if(swatchesShown < 6 && !!prodImgData && groupItem !== productHandle) {
							swatchItemsHTML += renderCollectionSwatch($swatchesWrap, {
								value: prodImgData[0],
								title: prodImgData[0],
								style: prodImgData[1],
								imageUrl: prodImgData[1],
								image: prodImgData[2],
								image1: prodImgData[3], 
								price: prodImgData[4], 
								color: prodImgData[5],
								colorName : color_name,
								colorId: color_id,
								handle: groupItem,
                                isSelected : false
							});
							swatchesShown++;
						}
						swatchesTotal++;
					}
				});
				if(swatchesTotal > 6) 
				{
					swatchItemsHTML += `<a href="/products/${productHandle}" class="productitem-swatches-count">+more colors</a>`;
				}
			}
			if(!!swatchItemsHTML && $swatchesWrap) 
			{
                // swatchItemsHTML += $swatchesWrap.innerHTML;
				$swatchesWrap.innerHTML = swatchItemsHTML;
				const swatchItemMouseOverHandler = event => {
                    console.log('swatchItemMouseOverHandler');
					if(event.type == 'click' && getWindowWidth() <= 767) {
						event.preventDefault();
					}
					const $target = event.target;
					const targetHref = $target.getAttribute('href');
					const $productItem = $target.closest('.product-card');
					$productItem.data = { swatchTarget: $target };
					$productItem.querySelectorAll('.product-card__media').forEach(productItemAnchor => {
						productItemAnchor.setAttribute('href', targetHref);
					});
					const $imgPrimary = $productItem.querySelector('.product-card__image--primary');
					const $imgAltenate = $productItem.querySelector('.product-card__image--secondary');
					updateProductItemImage($imgPrimary, $target.getAttribute('data-thumb'), $target);
					updateProductItemImage($imgAltenate, $target.getAttribute('data-thumbalt'), $target);
				};

				// $swatchesWrap.querySelectorAll('a.ProductItem__Swatches--Item').forEach($swatchItem => {
				// 	$swatchItem.addEventListener('mouseover', swatchItemMouseOverHandler);
				// 	$swatchItem.addEventListener('change', swatchItemMouseOverHandler);
				// });
				const $productItemImgPrimary = $productItem.querySelector('.product-card__image--primary');
				$productItemImgPrimary.onload = function() {
					const $productItem = this.closest('.product-card');
					if(!!$productItem.data && !!$productItem.data.swatchTarget) 
					{
						setProductItemSwatchActive($productItem.data.swatchTarget);
					}
				}
			}

			let color = !!window._collProdsImgData[productHandle] ? 'color: green' : 'color: red';
			if(!!swatchDebugVerbose) { console.log('%c'+productHandle, color); }
		}

		$productItem.classList.add('swatches-set');
	};

    $(document).on('change', '.card-color-swatch-list .custom-swatch-radio', function(e){
        e.preventDefault();
        let productHandle = $(this).data('handle');
        let productUrl = $(this).data('variant-url');
        let primaryImage = $(this).data('primary-image-url');
        let secondaryImage = $(this).data('secondary-image-url');
        let price = $(this).data('price');
        if (productUrl.length == 0) {
            return;
        }
        let parent = $(this).parents('.product-card');
        parent.find('a.product-card__media').attr('href', productUrl);
        parent.find('.quick-buy-modal').attr('handle', productHandle);
        parent.find('.product-card__image--primary').attr('src', primaryImage);
        parent.find('.product-card__image--secondary').attr('src', secondaryImage);
        parent.find('.product-card__image--primary').removeAttr('srcset');
        parent.find('.product-card__image--secondary').removeAttr('srcset');
        parent.find('.price-list sale-price').html(`<span class="sr-only">Sale price</span>${price}`);
        console.log('swatch change event');
    });
    
	window.renderCollProdsSwatches = () => {
		if(!!window.collSwatchFetchComplete) {
			const savedCollProdsImgData = sessionStorage.getItem('collProdsImgData') || window.collProdsImgData;
			window._collProdsImgData = {};
			savedCollProdsImgData.split('[,]').filter(item => !!item).forEach(item => {
				let items = item.split('[.]');
				let handle = items.shift();
				window._collProdsImgData[handle] = items;
			});
			document.querySelectorAll('.product-card:not(.swatches-set) a.product-card__media').forEach(item => {
				if(item.closest('[data-section-type="recently-viewed-products"]') === null) {
					renderCollProdItemSwatches(item);
				}
			});
		}
	};

	setInterval(window.renderCollProdsSwatches, 1000);

	$(document).on('change', 'select[name=id]', function() {
		changePresaleInfo();
	});

	const upperize = obj => Object.keys(obj).reduce((acc, k) => {
		acc[k.toUpperCase()] = obj[k];
		return acc;
	}, {});

	function changePresaleInfo()
	{
		var sku = $('select[name=id] option:selected').data('sku');
		if (sku) {
			sku = sku.toUpperCase();
			let variant = $('select[name=id]').val();
			let size = selectedSizeName().toUpperCase();
			let presale_info = $('.presale-info');
			if (presale_info.length != 0) {
				var presale = presale_info.data('presale');
				presale = upperize(presale);
				var presale_text = presale_info.data('presale-text');
				presale_text = presale_text.replace('##size##', size);
				$('.presale-info .Presale__Text').html(presale_text);
				let v = $(`.presale-variant-info[data-variant=${variant}]`);
				if (v) {
					let v_q = v.data('quantity');
					if (v_q <= presale[sku]) {
						updateCartButtonAndPresaleInfo(true)
					}else{
						updateCartButtonAndPresaleInfo(false)
					}
				}else{
					updateCartButtonAndPresaleInfo(false)
				}
			}else{
				updateCartButtonAndPresaleInfo(false)
			}
		}
	}

	function updateCartButtonAndPresaleInfo(show = false)
	{
		let cart_btn_text = $('.presale-info').data('cart-btn-text');
		let presale_btn_text = $('.presale-info').data('presale-btn-text');

		if (show) {
			$('.presale-info').show();
			$('.ProductForm__AddToCart.Button[data-action=add-to-cart] span').html(presale_btn_text);
			$('.ProductForm__AddToCart.Button[data-action=add-to-cart]').addClass('presale-active');
		}else{
			$('.presale-info').hide();
			$('.ProductForm__AddToCart.Button[data-action=add-to-cart] span').html(cart_btn_text);
			$('.ProductForm__AddToCart.Button[data-action=add-to-cart]').removeClass('presale-active');
		}
	}
	changePresaleInfo();
})(jQuery);